<template>
    <div class="container-fluid background-red">
        <div class="row">
            <div class="footer">
                <ul class="disclaimer text-center">
                    <li>
                        <a href="https://www.kwastwijnkopers.nl/contact/disclaimer/" target="_blank">
                            Disclaimer
                        </a>
                    </li>
                    <li>
                        <a href="https://www.kwastwijnkopers.nl/contact/algemene-voorwaarden/" target="_blank">
                            Algemene voorwaarden
                        </a>
                    </li>
                    <li>
                        <a href="https://www.kwastwijnkopers.nl/contact/privacy-statement/" target="_blank">
                            Privacy statement
                        </a>
                    </li>
                </ul>

                <div class="row info-row">
                    <div class="col">
                        <img src="/images/logo_white.svg" class="clickable" @click="navigateHome"/>
                    </div>
                    <div class="col">
                        <ul class="info">
                            <li class="list-title">
                                Kwast wijnkopers
                            </li>
                            <li>Roggestraat 30</li>
                            <li>2153 GC Nieuw Vennep</li>
                            <li>0252 68 67 41</li>
                        </ul>
                        <BaseButton
                            type="button"
                            text="Route"
                            design="small"
                            @buttonClick="openMapsUrl"
                        ></BaseButton>
                    </div>
                    <div class="col">
                        <ul class="info">
                            <li class="list-title">
                                Vragen?
                            </li>
                            <li>Wij staan altijd</li>
                            <li>klaar om u verder</li>
                            <li>te helpen</li>
                        </ul>
                        <BaseButton
                            class="button-small"
                            type="button"
                            text="Contact"
                            design="small"
                            @buttonClick="openContactUrl"
                        ></BaseButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { watch } from 'vue';
import { useRouter } from 'vue-router';
import BaseButton from '@/shared/components/BaseButton.vue';
import { useAuthStore, useModalStore } from '@/stores';

export default {
    components: {
        BaseButton,
    },
    setup() {
        function openMapsUrl() {
            window.open('https://goo.gl/maps/MTMdk8k5iygEgSqN6', '_blank');
        }

        function openContactUrl() {
            window.open('https://www.kwastwijnkopers.nl/contact/', '_blank');
        }

        const router = useRouter();
        const authStore = useAuthStore();
        const modalStore = useModalStore();
        
        function navigateHome() {
            window.scrollTo(0, 0);
            router.push({ name: 'Assortiment' });
        }

        // Function to manage typebot visibility
        function manageTypebotVisibility() {
            const isAuthenticated = authStore.isAuthenticated;
            const isModalOpen = modalStore.show !== '' 
                               || modalStore.showNavMobile 
                               || modalStore.showFilter 
                               || modalStore.loading;
            
            // Show typebot only if user is authenticated AND no modal is open
            const shouldShowTypebot = isAuthenticated && !isModalOpen;
            
            if (shouldShowTypebot) {
                // Only add typebot if it doesn't already exist
                const existingBubble = document.querySelector('typebot-bubble');
                if (!existingBubble) {
                    const typebotInitScript = document.createElement('script');
                    typebotInitScript.id = 'typebot';
                    typebotInitScript.type = 'module';
                    typebotInitScript.innerHTML = `import Typebot from 'https://cdn.jsdelivr.net/npm/@typebot.io/js@0.2.41/dist/web.js'

Typebot.initBubble({
    typebot: "kwast-wijnkopers-website",
    apiHost: "https://tbview.sevenlab.nl",
    previewMessage: {
        message: "Hulp nodig bij het kiezen van een wijn? Vraag het aan onze AI wijn sommelier!",
        autoShowDelay: 2000,
        avatarUrl: "https://www.kwastwijnkopers.nl/wp-content/themes/b4st-master/theme/images/grapes.svg",
    },
    theme: {
        button: { backgroundColor: "#aa0132" },
        chatWindow: { backgroundColor: "#fff" },
    },
});
`;
                    document.body.append(typebotInitScript);
                }
            } else {
                // Remove Typebot script
                const typebotInitScript = document.getElementById('typebot');
                if (typebotInitScript) {
                    typebotInitScript.remove();
                }

                // Remove Typebot bubble
                const typebots = document.getElementsByTagName('typebot-bubble');
                if (typebots.length > 0) {
                    // eslint-disable-next-line no-plusplus
                    for (let i = 0; i < typebots.length; i++) {
                        typebots[i].remove();
                    }
                }
            }
        }

        // Watch authentication status and all modal states
        watch([
            () => authStore.isAuthenticated, 
            () => modalStore.show,
            () => modalStore.showNavMobile,
            () => modalStore.showFilter,
            () => modalStore.loading,
        ], () => {
            manageTypebotVisibility();
        }, { immediate: true });

        return {
            openMapsUrl,
            openContactUrl,
            navigateHome,
        };
    },
};
</script>

<style scoped lang="scss">
@import "~@/assets/variables";

.container-fluid {
    color: $white;
    padding-bottom: 70px;

    .footer {
        max-width: 58.75rem;
        margin: 0 auto;

        .disclaimer {
            list-style: none;
            border-bottom: 1px solid white;
            width: 100%;
            margin-bottom: 3.125rem;
            padding: 0;

            li {
                margin: 2.2rem 1.25rem;
                display: inline-block;
                text-transform: uppercase;

                a {
                    font-family: "DINPro", sans-serif;
                    font-stretch: semi-condensed;
                    font-size: 1.125rem;
                    line-height: 28px;
                    text-decoration: none;
                    color: white;
                    letter-spacing: 1.2px;

                    &:hover {
                        border-bottom: 1px solid $white;
                    }
                }
            }
        }

        .info {
            list-style: none;
            width: 100%;
            text-align: left;
            margin-bottom: 1.5625rem;
            padding: 0;

            li {
                font-family: "DINPro", sans-serif;
                font-weight: 300;

                &.list-title {
                    font-weight: 400;
                }
            }
        }
    }

    &.background-red {
        background: $kwast-red;
    }
}

@media only screen and (max-width: 992px) {
    .container-fluid {

        .footer {

            .disclaimer {
                padding: 2.1875rem 0 0.3125rem 0;
                display: flex;
                flex-direction: column;
                margin-bottom: 0;
                li {
                    margin: 0 1.25rem;
                }
            }

            .info-row {
                flex-direction: column;
                .col {
                    text-align: center;
                    .info {
                        margin: 4.5rem 0 0 0;
                        text-align: center;
                    }
                    img {
                        display: inline-block;
                        margin: 4.5rem 0 0 0;
                    }
                    button {
                        display: inline-block;
                    }
                }
            }
        }
    }
}
</style>
